import { SkippedReviewsSort, exportSkippedReviewsCSV, getSkippedReviews } from '../../services/MetricsDashboardService'
import useAdminReviewsPage from '../../hooks/useAdminReviewsPage'
import ReviewsFilters from '../molecules/dashboard/ReviewsFilters'
import SkippedReviewsTable from '../molecules/dashboard/SkippedReviewsTable'
import InfoTooltip from '../atoms/InfoTooltip'
import { BackLink } from '../organisms/BackLink'
import { SkippedReview } from '../../types/metrics'

const SORT_FIELDS = ['skipDate', 'periodName', 'reviewerName', 'employeeName', 'reason'] as const

const AdminSkippedReviews = (): JSX.Element => {
  const { filtersProps, tableProps } = useAdminReviewsPage<SkippedReview, SkippedReviewsSort>({
    sortFields: SORT_FIELDS,
    fetchPage: getSkippedReviews,
    exportFn: exportSkippedReviewsCSV,
    errorMessage: 'Could not load skipped reviews.',
  })

  return (
    <main className="container mx-auto pb-16">
      <BackLink />
      <section className="mt-10 flex flex-col gap-6">
        <div className="flex items-center gap-2">
          <h1 className="text-5xl font-semibold text-dark-blue">Skipped Reviews</h1>
          <InfoTooltip text="All reviews skipped across the platform — filterable by period, reviewer, or employee, and sortable by skip date or reason." />
        </div>
        <ReviewsFilters idPrefix="skipped-reviews" {...filtersProps} />
        <SkippedReviewsTable {...tableProps} />
      </section>
    </main>
  )
}

export default AdminSkippedReviews
